import React from "react";
import { FunctionalButton } from '../../components/functionalButton';
import PledgxLogo from "assets/common/pledgxLogo";

import {
  LargeText,
  SmallText,
  ButtonArea,
  PopupContainer,
} from './styles';
import { Popup } from '../../components/popup';
import { CloseButton } from "components/closeButton";

export const SuccessPopup = ({
  openPopup,
  setOpenPopup,
  buttonText='DONE',
  descriptionText='Your information has been saved.',
  titleText='Success!',
  isMobile
}) => {

  const handleDone = () => {
    setOpenPopup(false);
  };

  return (
    <Popup
        open={openPopup}
        setOpen={setOpenPopup}
        width={isMobile ? "100%" : "400px"}
        height={isMobile ? "390px" : "280px"}
        dialogContent={(
          <>
            <PopupContainer>
              <CloseButton handleClose={handleDone} />
              <PledgxLogo width={isMobile ? 45 : ""} height={isMobile ? 45 : ""} />
              <LargeText isMobile={isMobile}>{ titleText }</LargeText>
              <SmallText>
                { descriptionText }
              </SmallText>
            </PopupContainer>
            <ButtonArea isMobile={isMobile}>
              <FunctionalButton
                buttonTitle={ buttonText }
                width="90%"
                height={isMobile ? "48px" : "53px"}
                marginRight="0px"
                handleButton={handleDone}
              />
            </ButtonArea>
        </>
        )}
      />

  )
}
